/* eslint-disable */
import React,{useEffect,useState} from 'react'
import UserService from '../services/UserService';
import { Dropdown } from 'reactstrap';

const EditableRow = ({editFormData,handleEditFormChange,handelfilechange,answer,handleCancel}) => {
    const[categoryData,SetCategory]=useState([]);
    const[storeData,SetStore]=useState([]);
    
    useEffect(()=>{
  
       UserService.getStore().then((res)=>SetStore(res.data))
       UserService.getCategory().then((res)=>SetCategory(res.data))
      },[]);
    //    console.log(categoryData) 
    //    console.log(storeData)

    // console.log(editFormData.file)

   const handleChange=()=>{

    }
   const fileChange=()=>{

    }
  return (
    <tr> 
        {/* <td><div>
          <label>{editFormData.Id}</label>
        </div>
            </td> */}
        {/* new: empty first cell, so the boxes line up with the "DEAl Id" column added in ReadOnlyDeals.js */}
        <td></td>
        <td>
       
        <div>
            <select name="storeId" onChange={handleEditFormChange} value={editFormData.storeId}>
            <option disabled value={0}>Select Store</option>
                      {storeData.map((data) =>
                        <option key={data.store_id} value={data.store_id} >{data.store}</option>)}
            </select>
        </div>
        </td>
        <td>
            <div>
                <select name="categoryId" onChange={handleEditFormChange} value={editFormData.categoryId}>
                <option disabled value={0}>Select Category</option>
                {categoryData.map((data, i) =>
                <option key={data.category_id} value={data.category_id}>{data.category}</option>)}  
                </select>
            </div>
        </td>
        <td>
        {/* old: onClick={handleEditFormChange}  (with onClick React never updates the text, so the box looked read-only) */}
        {/* new: onChange, so typing works */}
        <input type="text"
            required="required"
            placeholder='Enter a commondiscription'
            name='commondiscription'
            onChange={handleEditFormChange}
            value={editFormData.commondiscription}>
            </input>
        </td>
        <td>
            {!answer &&
            <>
               <p>{answer}</p>
            <img src={editFormData.file} style={{width:'100px'}}></img>
               </>  
            } 
        
        <input id="fileSelect" type="file" name='file' onChange={handelfilechange}  />
        </td>
        
        {/* old: <button onClick={handleCancel}>cancel</button>  (inside a form, a plain button also SUBMITS = saves) */}
        {/* new: type="button" so Cancel only cancels */}
        <td><button type="submit">save</button>
        <button type="button" onClick={handleCancel}>cancel</button>
        </td>        
    </tr>
  )
}

export default EditableRow